import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import PageAction from '../../../components/PageAction';
import PageTitle from '../../../components/PageTitle';
import TableBasic from '../../../components/Tablebasic';
import { useHealthAuthorityRegion } from '../../../hooks';
import { breachcrumbPath } from '../../../utils/breadcrumbConst';

const HealthAuthorityRegion = () => {
  const location: any = useLocation();
  const {
    nameSingle,
    name,
    baseUrl,
    healthAuthorityRegions,
    selectedHealthAuthorityRegions,
    getHealthAuthorityRegions,
    handleCheck,
    selectedValue,
    setSelectedValue,
    handleMenuAction,
  } = useHealthAuthorityRegion();

  const [toastMessage, setToastMessage] = useState<IToastMessage>();

  useEffect(() => {
    getHealthAuthorityRegions();
  }, []);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastMessage(location.state.toastMessage);
    }
  }, [location]);

  return (
    <AppWrapper
      toastMessage={toastMessage}
      breadcrumbs={[breachcrumbPath.core, breachcrumbPath.healthAuthorityRegion]}
    >
      <PageTitle
        title={`Select ${nameSingle} to change`}
        linkUrl={`/${baseUrl}/add`}
        buttonText={`add ${nameSingle}`}
        useIcon
        showButton
      />
      <PageAction
        name={nameSingle}
        count={healthAuthorityRegions.length}
        selectedCount={selectedHealthAuthorityRegions.length}
        selectedValue={selectedValue}
        onChange={setSelectedValue}
        handleClick={handleMenuAction}
      />
      <TableBasic
        data={healthAuthorityRegions || []}
        selectedList={selectedHealthAuthorityRegions}
        handleCheck={handleCheck}
        footerText={`${healthAuthorityRegions.length} ${name}`}
        basicUrl={`/${baseUrl}`}
      />
    </AppWrapper>
  );
};

export default HealthAuthorityRegion;
